<div class="container" [class.overlay]="isOverlay">
    <header>
        <div class="wrap inner relative">
            <h1 class="logo">
                <a></a>
            </h1>
            <search class="header-contents" (getWeatherEvent)="getWeatherData($event)" (searchResultEvent)="setAddress($event)"></search>
            <div class="header-menu-box">
                <a class="menu-btn accountName">
                    <span>
                        {{ getAccountName() }}
                    </span>
                </a>
                <a class="menu-btn" (click)="logout()">
                    {{ "common.logout" | translate }}
                </a>
                <a class="menu-btn type-lang" (click)="toggleLanguage()">
                    {{ isKorean()? "한국어" : "ENGLISH" }}
                </a>
                <a class="setting-btn" (click)="toggleFlightConfigurationSettingVisible()"></a>
            </div>
        </div>
    </header>
    <div class="wrapper">
        <summary></summary>
        <configuration (getChangeUnitEvent)="changeUnitEvent($event)" (getChangeFlightConfigEvent)="changeFlightConfigEvent($event)" (getChangeGustEvent)="changeGustEvent($event)" (toggleOverlayEvent)="toggleOverlayVisible()"></configuration>
        <weather-table></weather-table>
    </div>
    <footer>
        <div class="inner wrap relative">
            <div class="footer-logo">
                <a></a>
            </div>
            <div class="footer-menu">
                <div class="menu-box">
                    <a>
                        {{ "footer.companyInfo" | translate }}
                    </a>
                </div>
                <div class="menu-box">
                    <a>
                        {{ "footer.terms" | translate }}
                    </a>
                </div>
                <div class="menu-box">
                    <a>
                        <b>
                            {{ "footer.privacyPolicy" | translate }}
                        </b>
                    </a>
                </div>
            </div>
            <div class="footer-con">
                <div class="row">
                    <div class="item">
                        <span class="accent">
                            T.
                        </span>
                        070-8740-5534
                    </div>
                    <div class="item">
                        <span class="accent">
                            F.
                        </span>
                        070-8740-1730
                    </div>
                    <div class="item">
                        <span class="accent">
                            e-mail.
                        </span>
                        &nbsp;ceo@igis.co.kr
                    </div>
                </div>
                <div class="row type-copyright">
                    <div class="item">
                        Copyright ⓒ IGIS Co., Ltd. All Rights Reserved.
                    </div>
                </div>
            </div>
        </div>
    </footer>

    <article class="popup popup-custom" *ngIf="alertData.isVisible">
        <div class="popup-wrap">
            <div class="tit-box type-center">
                <div class="tit-txt">
                    {{ alertData.title }}
                </div>
            </div>
            <div class="custom-box">
                <div class="custom-con">
                    {{ alertData.message }}
                </div>
                <div class="custom-menu">
                    <a class="menu-btn type2" (click)="closeAlert()">
                        {{ "popup.confirm" | translate }}
                    </a>
                </div>
            </div>
        </div>
    </article>
</div>
